module.exports = __webpack_public_path__ + "img/logo-szrq.a1143525.png";